<template>
<span :style="messageStyle">{{message}}</span>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            default: "데이터가 없습니다."
        },
        fontSize: {
            type: String,
            default: "2.777vw"
        },
        paddingTop: {
            type: String,
            default: "0%"
        },
        centerMode: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        messageStyle() {
            let value = `font-size:${this.fontSize};padding-top:${this.paddingTop};`
            value += this.centerMode ? `display:flex; justify-content:center;` : "";
            return value;
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/common/EmptyMessage.vue